module.exports = __webpack_public_path__ + "/images/cover-mujeres-consultando-ordenador-540.dd3207e.jpg";